var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coin-balance"},[_c('div',{staticClass:"coin-icon"},[_vm._v("F")]),_c('span',{staticClass:"coin-amount"},[_vm._v(_vm._s(_vm.userCoins.toLocaleString()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }